/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Kind_WebInputs */

const en_fc_dl_kind_web = /** @type {(inputs: Fc_Dl_Kind_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web build (WebAssembly, self-host)`)
};

/**
* | output |
* | --- |
* | "Web build (WebAssembly, self-host)" |
*
* @param {Fc_Dl_Kind_WebInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_kind_web = /** @type {((inputs?: Fc_Dl_Kind_WebInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Kind_WebInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_kind_web(inputs)
});
export { fc_dl_kind_web as "fc.dl.kind.web" }